module.exports = {
	model: {
		info: ''
	},

	hooks: {
		showFieldDescription: function($element, options){
			options = options || {};

			if(options.info){
				this.model.info = options.info;
				this.refresh();
			}
		},

		hideFieldDescription: function($element, options){
			this.model.info = '';
			this.refresh();
		}
	}
}